import { Amount, asAmount } from "./Amount";
import { Currency } from "./Currency";
import Decimal from "decimal.js";
import { Nominal } from "@goodfill/nominal";

export interface Money {
  amount: Amount;
  currency: Currency;
}

export function usd(usDollars: string | Decimal): Money {
  const decimalAmount: Decimal = usDollars instanceof Decimal ? usDollars : new Decimal(usDollars);
  return {
    amount: asAmount(decimalAmount),
    currency: Currency.USD,
  };
}

export type NominalMoney<T extends string> = Money & Nominal<T>;
